module.exports = __webpack_public_path__ + "static/media/Logo Video.c4ae8c04.mp4";